<!--
 * @Author: Merlin
 * @Date: 2024-04-05 15:10:06
 * @LastEditors: Merlin
 * @LastEditTime: 2024-04-05 15:27:37
 * @Description: 
-->
<template>
    <div>
        <slot name="playing-area-right">
            
        </slot>
    </div>
</template>





